import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=5d4c2d8d&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d4c2d8d')) {
      api.createRecord('5d4c2d8d', component.options)
    } else {
      api.reload('5d4c2d8d', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=5d4c2d8d&", function () {
      api.rerender('5d4c2d8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b7mPG6zwIz4P/JS/comp/IncreaseNumber.vue"
export default component.exports